// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D7p0","toggleWrap":"styles_toggleWrap__1lJzL","content":"styles_content__X7FLn","selectAreaCode":"styles_selectAreaCode__3iqDr"};